import {Product} from '../../@types/wishlist.js';
import {AbstractApi} from './abstract-api.js';

export class ProductApiInstance extends AbstractApi {
  async getProduct(endpoint: string, syan: string, articleId?: string, colorId?: string): Promise<Product> {
    const articleIdParam = this.isSet(articleId) ? `?articleId=${articleId}` : '';
    let colorIdParam = '';
    if (this.isSet(colorId) && this.isSet(articleId)) {
      colorIdParam += `&colorId=${colorId}`;
    } else if (this.isSet(colorId)) {
      colorIdParam += `?colorId=${colorId}`;
    }
    const url = `${endpoint}${syan}${articleIdParam}${colorIdParam}`;

    return this.get<Product>(url, 'Wishlist product');
  }

  private isSet(param?: string): boolean {
    return param !== undefined && param !== '' && param !== null  && param !== 'null';
  }
}

export const productApi = new ProductApiInstance();
